// C:\Users\User\Desktop\Bresco\bresco-franquicies-frontend\src\components\ui\Modals\BulkEditEstadoModal.js
import PropTypes from "prop-types";
import { useState } from "react";
import { LuX, LuSquarePen } from "react-icons/lu";

const estadoSiniestroOptions = [
  { value: "", label: "— Selecciona un estado —" },
  { value: "ENVIADO CHUBB", label: "ENVIADO CHUBB" },
  { value: "PENDIENTE PAGO BA", label: "PENDIENTE PAGO BA" },
  { value: "REVISADO", label: "REVISADO" },
  { value: "ACEPTADO CHUBB", label: "ACEPTADO CHUBB" },
  { value: "ENVIO FINIQUITO MRW", label: "ENVIO FINIQUITO MRW" },
  { value: "RECIBO FINIQUITO FIRMADO", label: "RECIBO FINIQUITO FIRMADO" },
  { value: "LIQUIDADO", label: "LIQUIDADO" },
  { value: "CERRADO", label: "CERRADO" },
  { value: "BAJO FRANQUICIA", label: "BAJO FRANQUICIA" },
  { value: "CANCELADO", label: "CANCELADO" },
  { value: "PENDIENTE DOC MRW", label: "PENDIENTE DOC MRW" },
  { value: "DOC PEDIDA", label: "DOC PEDIDA" },
  { value: "NO TRAMITABLE", label: "NO TRAMITABLE" },
];

export default function BulkEditEstadoModal({ onClose, selectedIds, onConfirm }) {
  const [estado, setEstado] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const handleConfirm = async () => {
    if (!estado) {
      setError("Debes seleccionar un estado.");
      return;
    }
    setError(null);
    setLoading(true);
    try {
      await onConfirm(selectedIds, estado);
      onClose();
    } catch (err) {
      setError(err?.message || "Error al actualizar los registros.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div
      className="fixed inset-0 z-30 overflow-y-auto bg-black/50 backdrop-blur-sm"
      aria-labelledby="bulk-modal-title"
      role="dialog"
      aria-modal="true"
    >
      <div className="flex items-center justify-center min-h-screen px-4 text-center">
        <span className="hidden sm:inline-block sm:align-middle sm:h-screen" aria-hidden="true">
          &#8203;
        </span>

        <div className="relative inline-block w-full max-w-md p-7 overflow-hidden text-left align-middle transition-all transform bg-white border-2 shadow-xl outline-none sm:my-8 rounded-2xl border-[#FCAE52]">
          {/* Header */}
          <div className="flex items-start justify-between mb-5">
            <div className="flex items-center gap-3">
              <div className="flex items-center justify-center w-10 h-10 rounded-full border-[3px] border-[#FCAE52]">
                <LuSquarePen className="text-gray-700" size={20} />
              </div>
              <div>
                <p id="bulk-modal-title" className="text-lg font-semibold text-gray-800">
                  Edición masiva
                </p>
                <p className="text-sm text-gray-500">
                  {selectedIds.length} registro{selectedIds.length !== 1 ? "s" : ""} seleccionado{selectedIds.length !== 1 ? "s" : ""}
                </p>
              </div>
            </div>
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="flex items-center justify-center p-1.5 text-gray-400 transition-colors duration-200 bg-transparent rounded-full hover:bg-gray-100 disabled:opacity-50"
              aria-label="Cerrar modal"
            >
              <LuX size={22} />
            </button>
          </div>

          {/* Body */}
          <div className="space-y-4">
            <div>
              <label
                htmlFor="bulk-estado"
                className="block mb-1.5 text-sm font-semibold text-gray-700"
              >
                Estado siniestro
              </label>
              <select
                id="bulk-estado"
                value={estado}
                onChange={(e) => {
                  setEstado(e.target.value);
                  setError(null);
                }}
                disabled={loading}
                className="block w-full p-2.5 text-sm text-gray-700 bg-white border border-gray-300 rounded-lg focus:ring-2 focus:ring-[#FCAE52] focus:border-[#FCAE52] focus:outline-none disabled:opacity-50"
              >
                {estadoSiniestroOptions.map((o) => (
                  <option key={o.value} value={o.value}>
                    {o.label}
                  </option>
                ))}
              </select>
            </div>

            {error && (
              <p className="text-sm text-red-600">{error}</p>
            )}

            <p className="text-xs text-gray-400">
              Se actualizará el campo <strong>Estado siniestro</strong> en todos los registros seleccionados.
              Esta acción no se puede deshacer.
            </p>
          </div>

          {/* Footer */}
          <div className="flex justify-end gap-3 pt-6 mt-2">
            <button
              type="button"
              onClick={onClose}
              disabled={loading}
              className="h-10 px-5 text-sm font-semibold text-gray-600 transition-colors duration-150 bg-white border border-gray-300 rounded-xl hover:bg-gray-50 disabled:opacity-50"
            >
              Cancelar
            </button>
            <button
              type="button"
              onClick={handleConfirm}
              disabled={loading || !estado}
              className="h-10 px-5 text-sm font-semibold text-white transition-colors duration-150 bg-[#FCAE52] border border-[#FCAE52] rounded-xl hover:bg-[#e99d3f] disabled:opacity-50 disabled:cursor-not-allowed"
            >
              {loading ? "Guardando..." : "Confirmar"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}

BulkEditEstadoModal.propTypes = {
  onClose: PropTypes.func.isRequired,
  selectedIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  onConfirm: PropTypes.func.isRequired,
};